import React from 'react'
import './HomeFootNote.css'

export default function HomeFootNote() {
    return (
        <div className='HomeFootNoteContainer mt-5'>
            <div className='container'>
                <ul className='notes-items text-start list-unstyled mb-0 py-4'>
                    <li className='notes-item py-2 py-lg-1'>
                        <span className='notes-item-text'>
                            1. Trade‑in values will vary based on the condition, year, and configuration of your eligible trade‑in device. Not all devices are eligible for credit. You must be at least the age of majority to be eligible to trade in for credit or for an Apple Gift Card. Trade‑in value may be applied toward qualifying new device purchase, or added to an Apple Gift Card. Actual value awarded is based on receipt of a qualifying device matching the description provided when estimate was made. Sales tax may be assessed on full value of a new device purchase. In‑store trade‑in requires presentation of a valid photo ID (local law may require saving this information). Offer may not be available in all stores and may vary between in‑store and online trade‑in. Some stores may have additional requirements. Apple or its trade‑in partners reserve the right to refuse, cancel, or limit quantity of any trade‑in transaction for any reason. More details are available from Apple’s trade-in partner for trade‑in and recycling of eligible devices. Restrictions and limitations may apply.
                        </span>
                    </li>
                    <li className='notes-item py-2 py-lg-1'>
                        <span className='notes-item-text'>
                            To access and use all Apple Card features and products available only to Apple Card users, you must add Apple Card to Wallet on an iPhone or iPad that supports and has the latest version of iOS or iPadOS. Apple Card is subject to credit approval, available only for qualifying applicants in the United States, and issued by Goldman Sachs Bank USA, Salt Lake City Branch.
                        </span>
                    </li>
                    <li className='notes-item py-2 py-lg-1'>
                        <span className='notes-item-text'>
                            Apple Payments Services LLC, a subsidiary of Apple Inc., is a service provider of Goldman Sachs Bank USA for Apple Card and Savings accounts. Neither Apple Inc. nor Apple Payments Services LLC is a bank.
                        </span>
                    </li>
                    <li className='notes-item py-2 py-lg-1'>
                        <span className='notes-item-text'>
                            If you reside in the U.S. territories, please call Goldman Sachs at 877-255-5923 with questions about Apple Card.
                        </span>
                    </li>
                    <li className='notes-item py-2 py-lg-1'>
                        <span className='notes-item-text'>
                            Learn more about how Apple Card applications are evaluated at support.apple.com/kb/HT209218.
                        </span>
                    </li>
                    <li className='notes-item py-2 py-lg-1'>
                        <span className='notes-item-text'>
                            Features are subject to change. Some features, applications, and services may not be available in all regions or all languages.
                        </span>
                    </li>
                    <li className='notes-item py-2 py-lg-1'>

                    </li>

                </ul>
            </div>
        </div>
    )
}
